import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    picture: {
        height: (props) => props.height,
        width: (props) => props.width,
        margin: 3,
        display: 'flex',
        alignItems: 'center'
    },
    pictureTransparent: {
        height: (props) => props.height,
        width: (props) => props.width,
        margin: 3,
        display: 'flex',
        alignItems: 'center',
        opacity: 0.2
    },
}));

export {useStyles};